<template>
  <layout-block :has-border="false" :width="width" margin="48px 16px">
    <layout-block-head :title="ranking.title" padding-top="8px" padding-bottom="0" />
    <layout-block-section margin="16px 0">
      <table
        style="border-collapse: collapse;"
        width="100%"
        v-for="(r, idx) in ranking.data.sort((a, b) => a.rank - b.rank)"
        :key="`ranking-${idx}`"
        :style="{ borderBottom: idx + 1 < ranking.data.length ? '2px solid #E5E8EE' : 'none' }"
      >
        <tr>
          <td style=" position: relative;padding: 0; min-width: 72px; vertical-align: top;">
            <div
              v-if="ranking.your_rank.rank === r.rank"
              style="position: absolute; top:-2px; left:0; border-top:20px solid  #397CFF; border-right: 20px solid transparent; width: 0; height: 0; "
            ></div>
            <img
              :src="`https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/medal-${r.rank}.png`"
              width="72"
            />
          </td>
          <td
            :style="{ color: ranking.your_rank.rank === r.rank ? '#397CFF' : '#06152F' }"
            style=" padding: 16px 16px 16px 0; max-width: 1px; overflow: hidden; vertical-align: top;text-overflow: ellipsis; white-space: nowrap; font-size:14px; font-weight:600;"
            colspan="3"
          >
            <div style=" overflow: hidden;text-overflow: ellipsis; white-space: nowrap; ">
              {{ truncate(r.name, 41) }}
            </div>
          </td>
        </tr>
        <tr>
          <td style="min-width: 72px;"></td>
          <td style="width: 20%; font-weight:700;">{{ r.rating_value }}<span style="font-size:10px;">/5</span></td>
          <td style="width: 20%;">
            {{ r.rating_count }}
            <img :src="`https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/comment.png`" width="16px" />
          </td>
          <td style="padding: 0 16px 16px 0;width: 40%">
            <ui-trend :trend="r.trend" />
          </td>
        </tr>
      </table>
    </layout-block-section>

    <div style="color: #707070;font-size: 28px;font-weight: bold;" v-if="ranking.your_rank.rank > ranking.data.length">
      . . .
    </div>
    <layout-block-section margin="16px 0 32px" v-if="ranking.your_rank.rank > ranking.data.length">
      <table style="border-collapse: collapse;" width="100%">
        <tr>
          <td style=" position: relative;padding: 0; padding: 16px 0; min-width: 70px; vertical-align: top">
            <div
              style="position: absolute; top: 0; left:0; border-top:20px solid  #397CFF; border-right: 20px solid transparent; width: 0; height: 0; "
            ></div>
            <div style=" text-align: center;color: #397cff; font-size:14px; font-weight:800;">
              {{ ranking.your_rank.rank }}
            </div>
          </td>
          <td
            style=" padding: 16px 16px 16px 0; overflow: hidden; vertical-align: top;text-overflow: ellipsis; white-space: nowrap; font-size:14px; font-weight:600;"
            colspan="3"
          >
            <div style=" overflow: hidden;text-overflow: ellipsis; white-space: nowrap; color:#397cff">
              {{ truncate(ranking.your_rank.name, 41) }}
            </div>
          </td>
        </tr>
        <tr>
          <td style="min-width: 70px;"></td>
          <td style="width: 20%; font-weight:700;">
            {{ ranking.your_rank.rating_value }}<span style="font-size:10px;">/5</span>
          </td>
          <td style="width: 20%;">
            {{ ranking.your_rank.rating_count }}
            <img :src="`https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/comment.png`" width="16px" />
          </td>
          <td style="padding: 0 16px 16px 0;width: 40%">
            <ui-trend :trend="ranking.your_rank.trend" />
          </td>
        </tr>
      </table>
    </layout-block-section>
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockHead from '@/components/Layout/Block/Head.vue'
import LayoutBlockSection from '@/components/Layout/Block/Section.vue'
import UiTrend from '@/components/UI/Trend.vue'

export default {
  name: 'ReportRanking',
  components: {
    LayoutBlock,
    LayoutBlockHead,
    LayoutBlockSection,
    UiTrend,
  },
  props: {
    ranking: {
      type: Object,
      required: true,
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
  methods: {
    truncate(source, size) {
      return source.length > size ? source.slice(0, size - 1) + '...' : source
    },
    kFormatter(num) {
      return Math.abs(num) > 999 ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k' : num
    },
  },
}
</script>
